import Joi from "joi";
import { TypeMovimentPesticides } from "../../utils/enums/TypeMovimentPesticides"
import { customMessages } from "./messages";

function ValidateMovimentPerticides(moviment) {
  const schema = Joi.object({
    idAgrotoxico: Joi.number()
      .required()
      .messages(customMessages.idAgrotoxico),
    idResponsavel: Joi.string()
      .uuid({ version: 'uuidv4' })
      .when('tipo', {
        is: TypeMovimentPesticides.VENDA,
        then: Joi.required().messages(customMessages.idResponsavel),
        otherwise: Joi.allow('', null).optional()
      }),
    idFornecedor: Joi.string()
      .uuid({ version: 'uuidv4' })
      .when('tipo', {
        is: TypeMovimentPesticides.COMPRA,
        then: Joi.required().messages(customMessages.idFornecedor),
        otherwise: Joi.allow('', null).optional()
      }),
    naturezaOperacao: Joi.string().max(255).required().messages(customMessages.naturezaOperacao),
    quantidade: Joi.number().required().messages(customMessages.quantidade),
    idEmbalagem: Joi.number().allow('', null).optional(),
    embalagem: Joi.string().required().messages(customMessages.embalagem),
    lote: Joi.string().allow('', null).optional(),
    data: Joi.date().required().messages(customMessages.data),
    dataNfe: Joi.date().required().messages(customMessages.dataNfe),
    destinoProduto: Joi.string().valid('Dentro Estado', 'Fora Estado').required().messages(customMessages.destinoProduto),
    tipo: Joi.string().valid(...Object.values(TypeMovimentPesticides)).required().messages(customMessages.tipo),
    numeroNfe: Joi.number().required().messages(customMessages.numeroNfe),
    serieNfe: Joi.number().required().messages(customMessages.serieNfe),
  }).unknown(true)

  const { error } = schema.validate(moviment, { abortEarly: false })

  if (error?.details && error?.details.length) {
    const errors = error?.details.map(erro => {
      if (erro?.message || erro?.path[0]) {
        if (erro.path.length > 1) {
          return {
            message: erro?.message,
            keyError: erro?.path[1],
            type: erro.type.split('.')[1]
          }
        }

        return {
          message: erro?.message,
          keyError: erro?.path[0],
          type: erro.type.split('.')[1]
        }
      }
    })

    return errors
  }
}

export { ValidateMovimentPerticides }